import type { ChainList, ChainListItem, NetworkListItem } from 'lib/web3/chains'
import { SupportedEnv, SupportedEnvironments } from './environments'
import { Network, CHAIN_LIST, ProductionNetworks, TestingNetworks } from '@nsfw-app/crypto'

// NOTE: Update chainsMap.ts if new chains are added
const STAGE_CHAINS: Record<TestingNetworks, any> = {
  [Network.MUMBAI]: CHAIN_LIST[Network.MUMBAI],
  [Network.BINANCE_TESTNET]: CHAIN_LIST[Network.BINANCE_TESTNET],
  [Network.ARBITRUM_GOERLI]: CHAIN_LIST[Network.ARBITRUM_GOERLI],
  [Network.OPTIMISM_GOERLI]: CHAIN_LIST[Network.OPTIMISM_GOERLI]
}

const BETA_CHAINS: Record<ProductionNetworks, any> = {
  [Network.BINANCE]: CHAIN_LIST[Network.BINANCE],
  [Network.POLYGON]: CHAIN_LIST[Network.POLYGON],
  [Network.OPTIMISM]: CHAIN_LIST[Network.OPTIMISM],
  [Network.ARBITRUM]: CHAIN_LIST[Network.ARBITRUM]
}

const getChainsForEnv = (env: SupportedEnvironments): ChainList => {
  switch (env) {
    case SupportedEnv.STAGE:
      return STAGE_CHAINS
    case SupportedEnv.BETA:
      return BETA_CHAINS
    default:
      throw new Error('Unsupported Environment')
  }
}

export const CHAINS = getChainsForEnv(process.env.NEXT_PUBLIC_NSFW_ENV as SupportedEnvironments)

export const mapChainToNetwork = (id: Network, chain: ChainListItem): NetworkListItem => ({
  id: id,
  name: chain.name,
  symbol: chain.nativeCurrency.symbol
})
